export class SimulatorConversation {
  messages: any[] = [];

  addSystemMessage(msg: any) {
    this.messages.push({ ...msg });
  }
}


